import { DateLoadConfig } from "api/model/dashboard/DashboardTab";

export enum ScreenSizes {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
  EXTRA_SMALL = "extra-small",
}

export interface ICommonCalendarHeatmapProps {
  config: ICalendarHeatmapProps;
  onConfigChange: (newConfig: ICalendarHeatmapProps) => void;
}

export interface ICalendarHeatmapProps {
  identifier?: string;
  dataset?: HeatMapDataset[];
  isCustomDataset?: boolean;
  startDate: Date;
  setStartDate?: React.Dispatch<React.SetStateAction<Date>>;
  endDate: Date;
  setEndDate?: React.Dispatch<React.SetStateAction<Date>>;
  minValue?: number | undefined;
  maxValue?: number | undefined;
  lowValueTitle?: string | undefined;
  highValueTitle?: string | undefined;
  lowValueColor?: string;
  highValueColor?: string;
  showDateSelection?: boolean;
  staticMinMaxValues: boolean;
  staticMinMaxTitles: boolean;
  staticMinMaxColors: boolean;
  ignoreCurrentDay: boolean;
  useLoadConfig?: boolean;
  loadConf?: DateLoadConfig;
  hideHeader?: boolean;
}

export interface HeatMapDataset {
  [x: string]: any;
  date: Date;
  value: number;
}
